import * as React from 'react'
import ReactSelect, { Props as OriginalProps } from 'react-select'

type Props<T> = OriginalProps<T> & {
  backgroundColor?: string
}

const styles = (backgroundColor: string = 'white') => ({
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor,
    padding: '10px 15px',
    fontSize: '110%',
    color: state.isSelected === true ? '#OOO !important' : provided.color,
    fontWeight: state.isSelected === true ? 'bold' : 'inherit',
    ':active': {
      backgroundColor: '#c2c2c2',
    },
  }),
  container: (provided: any, state: any) => ({
    ...provided,
    backgroundColor,
    ':hover': {
      pointer: 'mouse',
    },
  }),

  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor,
    ':hover': {
      cursor: 'pointer',
      borderBottom: '2px solid',
    },

    ':focus': {
      outline: 'none',
      boxShadow: 'none',
    },
    borderColor: state.isFocused ? '#591841' : 'black',

    boxShadow: state.isFocused ? '#591841' : 'black',
    borderLeft: 'none',
    borderTop: 'none',
    borderRight: 'none',
    borderRadius: 0,
  }),

  singleValue: (provided: any, state: any) => ({
    ...provided,
    borderRadius: 26,
    height: 32,
    marginLeft: 4,
    paddingLeft: 8,
    paddingRight: 10,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: '110%',
    backgroundColor,
  }),

  multiValue: (provided: any, state: any) => ({
    ...provided,
    borderRadius: 26,
    height: 32,
    marginLeft: 4,
    paddingLeft: 8,
    paddingRight: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '110%',
    backgroundColor,
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    zIndex: 100,
  }),
  multiValueLabel: (provided: any, state: any) => ({
    fontSize: '100%',

    backgroundColor,
  }),
  multiValueRemove: (provided: any, state: any) => ({
    borderRadius: '50%',
    color: '#fff',

    backgroundColor: 'rgba(0, 0, 0, 0.26)',
    padding: '4px 4px',
    display: 'flex',
    marginLeft: 4,
  }),
})

export default function SelectMain(
  props: Props<{ label: string; value: any }>,
) {
  return <ReactSelect {...props} styles={styles(props.backgroundColor)} />
}
